import CMS_UPDATE_PREVIEW_OPTIONS from '../action-types';

// @ts-expect-error - Automatic, Please fix when editing this file
const updatePreviewOptions = (payload) => (dispatch) => {
  dispatch({ payload, type: CMS_UPDATE_PREVIEW_OPTIONS });
};

export default { updatePreviewOptions };
